import { toast as sonnerToast } from "sonner";

import { isErrorHandled, markErrorAsHandled } from "@/core/lib/handled-error";
export { sonnerToast };

type ToastOptions = {
  title: string;
  description?: string;
  severity?: "success" | "danger" | "warning" | "info" | "default" | "primary";
  duration?: number;
  id?: string | number;
  /**
   * Dedupe key. If the error has already triggered a toast in this session,
   * the call is a no-op; otherwise the toast fires and the error is marked
   * as handled so downstream wrappers won't double-fire for the same failure.
   */
  error?: unknown;
};

export const addToast = ({
  title,
  description,
  severity,
  duration = 5000,
  id,
  error,
}: ToastOptions) => {
  if (error !== undefined && isErrorHandled(error)) return;

  const type = severity || "info";
  const baseOptions = { description, duration, id };

  switch (type) {
    case "success":
      sonnerToast.success(title, baseOptions);
      break;
    case "danger":
      sonnerToast.error(title, baseOptions);
      break;
    case "warning":
      sonnerToast.warning(title, baseOptions);
      break;
    case "info":
    case "default":
    case "primary":
    default:
      sonnerToast.info(title, baseOptions);
      break;
  }

  if (error !== undefined) markErrorAsHandled(error);
};
